import { CLIENTS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(CLIENTS_ENDPOINT);
export default instance;
